import React, { useState, useEffect } from 'react'
import FieldDropdownV2 from 'src/components/FormComponents/FieldDropdownV2'
import FieldV2 from 'src/components/FormComponents/FieldV2'
import Suffix from "../Suffix"
import * as S from './ReceivementUnitForm.styles'
import InformationField from '../InformationField'

export default ({
  tiposAvaria,
  watch,
  control,
  handleOnKeyDown,
  setValue,
  resetField,
  dueDateTypeConfig,
  dueDateDamage,
  labelForDueDate,
  packQtyReadOnly
}) => {
  const tipoAvaria = watch('tipoAvarias')
  const [damageReadOnly, setDamageReadOnly] = useState(true)

  useEffect(() => {
    if (tipoAvaria === 'NENHUM') {
      setDamageReadOnly(true)
      resetField('quantidadeAvarias')
    } else if (tipoAvaria === 'DANO') {
      setDamageReadOnly(false)
      setValue('quantidadeAvarias', '')
    } else if (tipoAvaria === 'VENCIDO') {
      setDamageReadOnly(true)
    }
  }, [tipoAvaria])

  return (
    <>
      <S.Field
        as={FieldV2}
        control={control}
        name='qtdCaixas'
        labelText='Qtd. caixas'
        type='number'
        placeholder='0000'
        onKeyDown={(e) => handleOnKeyDown(e, packQtyReadOnly ? 'avulso' : 'caixaria')}
      />
      <S.Field
        as={FieldV2}
        control={control}
        name='caixaria'
        labelText='Caixaria'
        type={packQtyReadOnly ? 'text' : 'number'}
        placeholder='0000'
        onKeyDown={(e) => handleOnKeyDown(e, 'avulso')}
        readOnly={packQtyReadOnly}
      />
      <S.Field
        as={FieldV2}
        control={control}
        name='avulso'
        labelText='Avulso'
        type='number'
        placeholder='0000'
        onKeyDown={(e) => handleOnKeyDown(e, dueDateTypeConfig === 'INDETERMINATE' ? 'tipoAvarias' : 'validade')}
      />
      <Suffix suffix={'Un'}>
        <S.Field
          as={FieldV2}
          control={control}
          name='total'
          labelText='Total'
          value={watch('total')}
          readOnly
          onKeyDown={(e) => handleOnKeyDown(e, 'validade')}
        />
      </Suffix>
      {dueDateTypeConfig === 'INDETERMINATE' ? (
        <InformationField
          title='Validade'
          info='Automática'
          tooltipInfoMessage='Validade definida pelo sistema'
          testId='automatic-due-date-test-id'
        />
      ) : dueDateTypeConfig === 'LONG_DURATION' ? (
        <S.Field
          as={FieldV2}
          control={control}
          type='month'
          labelText={labelForDueDate}
          name='validade'
          onKeyDown={(e) => handleOnKeyDown(e, dueDateDamage ? 'quantidadeAvarias' : 'tipoAvarias')}
          inputTextColor={dueDateDamage ? 'red' : 'black'}
          width={'13rem !important'}
        />
      ) : (
        <S.Field
          as={FieldV2}
          control={control}
          type='date'
          labelText={labelForDueDate}
          name='validade'
          onKeyDown={(e) => handleOnKeyDown(e, dueDateDamage ? 'quantidadeAvarias' : 'tipoAvarias')}
          inputTextColor={dueDateDamage ? 'red' : 'black'}
        />
      )}
      {dueDateDamage ? (
        <InformationField
          title='Tipo Avaria'
          info='VENCIDO'
          tooltipInfoMessage='Lote definido automaticamente como vencido'
          testId='automatic-damage-type-test-id'
        />
      ) : (
        <S.Field
          as={FieldDropdownV2}
          control={control}
          labelText='Tipo avaria'
          type='text'
          name='tipoAvarias'
          onKeyDown={(e) => handleOnKeyDown(e, 'quantidadeAvarias')}
          options={tiposAvaria.map((v) => ({ value: v, label: v }))}
        />
      )}
      <Suffix suffix={'Un'}>
        <S.Field
          as={FieldV2}
          control={control}
          type='text'
          labelText='Qtd. avarias'
          name='quantidadeAvarias'
          placeholder='0000'
          readOnly={damageReadOnly}
        />
      </Suffix>
      <Suffix suffix={'Un'}>
        <S.Field
          as={FieldV2}
          control={control}
          name='qtdUtil'
          labelText='Qtd. Útil Total'
          value={watch('qtdUtil')}
          readOnly
        />
      </Suffix>
    </>
  )
}
